// src/redux/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface User {
  mitgliedID: number;
  username: string;
  // password: string; // NICHT im Frontend speichern!
  vorname: string;
  nachname: string;
  email: string;
  geburtsdatum: string; // Java LocalDate kommt als String (ISO 8601)
  adresse: string;
  telefon: string;
  mitgliedsstatus: string;
  beitrittsdatum?: string;
  roles: string[]; // <--- angepasst

  // Arrays können null sein im Backend, daher optional (?) oder Array
  ausleihen?: Ausleihe[];
  reservierungen?: Reservierung[];
  mahnungen?: Mahnung[];
}

export interface Ausleihe {
  ausleiheID: number;
  ausleihdatum: string; // Änderung: number -> string
  rueckgabedatum: string;
  rueckgabeStatus: string;
  // standort: string; // <--- ENTFERNT, da Backend das nicht liefert!
  exemplarID: number | null; // Kann null sein laut Backend
}

export interface Reservierung {
  reservierungID: number;
  reservierungsdatum: string;
  status: string;
  exemplarID: number | null;
}

export interface Mahnung {
  mahnungID: number;
  datum: string;
  betrag: number;
  status: string;
  ausleiheID: number | null;
}

interface UserState {
  user: User | null;
}

const initialState: UserState = {
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = null;
    },
    addAusleihe(state, action: PayloadAction<Ausleihe>) {
      if (!state.user) return;
      state.user.ausleihen = state.user.ausleihen || [];
      state.user.ausleihen.push(action.payload);
    },
    removeAusleihe(state, action: PayloadAction<number>) {
      // exemplarId entfernen
      if (!state.user || !state.user.ausleihen) return;
      state.user.ausleihen = state.user.ausleihen.filter(
        (a) => a.exemplarID !== action.payload,
      );
    },
    addReservierung(state, action: PayloadAction<Reservierung>) {
      if (!state.user) return;
      state.user.reservierungen = state.user.reservierungen || [];
      state.user.reservierungen.push(action.payload);
    },
    removeReservierung(state, action: PayloadAction<number>) {
      // reservierungID entfernen
      if (!state.user || !state.user.reservierungen) return;
      state.user.reservierungen = state.user.reservierungen.filter(
        (r) => r.reservierungID !== action.payload,
      );
    },
  },
});

export const {
  setUser,
  clearUser,
  addAusleihe,
  removeAusleihe,
  addReservierung,
  removeReservierung,
} = userSlice.actions;
export default userSlice.reducer;
